const cache = new Map();

/**
 * Loads a page's content chunk (src/content/generated/<chunk>.json) once.
 * Split out of ContentRoute so tests can replace it.
 */
export function loadChunk(chunk) {
  if (!cache.has(chunk)) {
    cache.set(
      chunk,
      import(`../content/generated/${chunk}.json`).then((m) => m.default ?? m)
    );
  }
  return cache.get(chunk);
}
